import {Component, h, Prop, State} from '@stencil/core';

const PADDING = 16;

@Component({
  tag: 'svs-carousel',
  styleUrl: ' ./svs-carousel.scss',
  shadow: false,
})
export class SvsCarousel {
  private container:HTMLElement;
  private list:HTMLElement;
  private observer:ResizeObserver;

  /**
   * allow hiding arrows when not needed
   */
  @Prop() readonly hidableArrows: boolean = false;

  @State() showArrows: boolean = this.hidableArrows;

  private handlePrev = ()=> {
      const currentPosition = this.container.scrollLeft;
      const nextEl = (Array.from(this.list.childNodes) as unknown as HTMLElement[])
        .reverse()
        .find(node=>node.offsetLeft - currentPosition < -5);

      if (nextEl) {
        this.container.scrollTo({
          top: 0,
          left: nextEl.offsetLeft - PADDING,
          behavior: 'smooth'
        });
      }
  };

  private handleNext = ()=> {
      const currentPosition = this.container.scrollLeft;
      const nextEl = (Array.from(this.list.childNodes) as unknown as HTMLElement[])
        .find(node=>node.offsetLeft - currentPosition > PADDING + 2);

      if (nextEl) {
        this.container.scrollTo({
          top: 0,
          left: nextEl.offsetLeft - PADDING,
          behavior: 'smooth'
        });
      }
  };

  private setArrowsVisibility = ()=>{
      const {offsetWidth, scrollWidth} = this.list || {};
      this.showArrows = this.hidableArrows && scrollWidth > offsetWidth;
  };

  componentDidLoad() {
      this.observer = new ResizeObserver(this.setArrowsVisibility);
      this.observer.observe(this.container);
  }

  disconnectedCallback() {
      this.observer?.disconnect?.();
  }



  render() {
      return <div class="svs-carousel-wrapper">

        <div class="svs-carousel-nav">
          <slot name="header" />
          <div class="svs-carousel-nav__spacer"></div>
          {this.showArrows && [<div>
            <qds-button onClick={this.handlePrev} size="small" icon-only="true" icon-name="chevron-left"> </qds-button>
          </div>,
          <div>
            <qds-button onClick={this.handleNext} size="small" icon-only="true" icon-name="chevron-right"> </qds-button>
          </div>]}
        </div>

        <div ref={el=>this.container = el} class="svs-carousel-container">
          <div ref={el=>this.list = el} class="svs-carousel">
            <slot />
          </div>
        </div>
      </div>;
  }
}
